import { useTranslation } from 'react-i18next';
import {
  FiCpu,
  FiGrid,
  FiImage,
  FiFilm,
  FiBox,
  FiCrosshair,
  FiZap,
  FiAlertTriangle,
  FiStar,
  FiShield,
  FiClock,
  FiTrendingUp,
  FiLayers,
  FiTarget,
  FiTool,
  FiUsers,
  FiMap,
  FiAward,
  FiDownload,
  FiChevronsLeft,
  FiChevronsRight,
} from 'react-icons/fi';
import { useEditorStore } from '../../stores/editorStore';
import type { EditorModule } from '../../types/editor';
import type { IconType } from 'react-icons';
import styles from './Sidebar.module.css';

interface NavEntry {
  module: EditorModule;
  icon: IconType;
  labelKey: string;
}

const NAV_ITEMS: NavEntry[] = [
  { module: 'ai-architect', icon: FiCpu, labelKey: 'nav.aiArchitect' },
  { module: 'viewport', icon: FiGrid, labelKey: 'nav.viewport' },
  { module: 'sprite', icon: FiImage, labelKey: 'nav.sprite' },
  { module: 'animation', icon: FiFilm, labelKey: 'nav.animation' },
  { module: 'entity', icon: FiBox, labelKey: 'nav.entity' },
  { module: 'combat', icon: FiCrosshair, labelKey: 'nav.combat' },
  { module: 'weapons', icon: FiZap, labelKey: 'nav.weapons' },
  { module: 'enemies', icon: FiAlertTriangle, labelKey: 'nav.enemies' },
  { module: 'perks', icon: FiStar, labelKey: 'nav.perks' },
  { module: 'powerups', icon: FiShield, labelKey: 'nav.powerups' },
  { module: 'spawner', icon: FiClock, labelKey: 'nav.spawner' },
  { module: 'xp-system', icon: FiTrendingUp, labelKey: 'nav.xpSystem' },
  { module: 'game-modes', icon: FiLayers, labelKey: 'nav.gameModes' },
  { module: 'turrets', icon: FiTarget, labelKey: 'nav.turrets' },
  { module: 'crafting', icon: FiTool, labelKey: 'nav.crafting' },
  { module: 'companions', icon: FiUsers, labelKey: 'nav.companions' },
  { module: 'environment', icon: FiMap, labelKey: 'nav.environment' },
  { module: 'meta-progression', icon: FiAward, labelKey: 'nav.metaProgression' },
  { module: 'export', icon: FiDownload, labelKey: 'nav.export' },
];

export function Sidebar() {
  const { t } = useTranslation();
  const activeModule = useEditorStore((s) => s.activeModule);
  const setActiveModule = useEditorStore((s) => s.setActiveModule);
  const sidebarOpen = useEditorStore((s) => s.sidebarOpen);
  const toggleSidebar = useEditorStore((s) => s.toggleSidebar);

  const collapsed = !sidebarOpen;

  return (
    <aside
      className={`${styles.sidebar} ${collapsed ? styles.sidebarCollapsed : ''}`}
    >
      <nav className={styles.navList}>
        {NAV_ITEMS.map(({ module, icon: Icon, labelKey }) => {
          const active = activeModule === module;
          return (
            <button
              key={module}
              className={`${styles.navItem} ${active ? styles.navItemActive : ''}`}
              onClick={() => setActiveModule(module)}
              title={collapsed ? t(labelKey) : undefined}
            >
              <span className={styles.navIcon}>
                <Icon />
              </span>
              {!collapsed && (
                <span className={styles.navLabel}>{t(labelKey)}</span>
              )}
            </button>
          );
        })}
      </nav>

      <button className={styles.toggleBtn} onClick={toggleSidebar}>
        {collapsed ? <FiChevronsRight /> : <FiChevronsLeft />}
      </button>
    </aside>
  );
}
